/**
 * A Parker's end date may not be set beyond December 31 of this many years out.
 * Kept here rather than in a component so Add New Parker, Edit Parker and Parker Import
 * all enforce the same ceiling.
 */
export const PARKER_MAX_END_DATE_YEARS_OUT: number = 20;

/** December 31 of the current year plus PARKER_MAX_END_DATE_YEARS_OUT. */
export function getParkerMaxEndDate(): Date {
  return new Date(new Date().getFullYear() + PARKER_MAX_END_DATE_YEARS_OUT, 11, 31);
}

export function getParkerMaxEndDateDisplay(): string {
  const maxEndDate: Date = getParkerMaxEndDate();

  return `${maxEndDate.getMonth() + 1}/${maxEndDate.getDate()}/${maxEndDate.getFullYear()}`;
}

/**
 * True when the supplied end date is past the ceiling.
 * A blank or unset end date means "no term date" and is always allowed.
 */
export function isParkerEndDateBeyondMax(endDate: Date | string | null | undefined): boolean {
  if (endDate === null || endDate === undefined || endDate === '') {
    return false;
  }

  const endDateValue: Date = endDate instanceof Date ? endDate : new Date(endDate);

  if (isNaN(endDateValue.getTime())) {
    return false;
  }

  // Compared on the calendar date alone so a time component cannot push Dec 31 over the line.
  const endDateOnly: Date = new Date(endDateValue.getFullYear(), endDateValue.getMonth(), endDateValue.getDate());

  return endDateOnly > getParkerMaxEndDate();
}
